module.exports = __webpack_public_path__ + "static/media/3.49bd579b.svg";